let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1669372352534x986080231628734500',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "For Junior specialists",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1669372261631x700263527819509800',
    },
];

export default PackagesItem;
